import './App.css'

import BrowserHistory from './components/BrowserHistory'

// These are the list used in the application. You can move them to any component needed.

// Replace your code here

const App = () => <BrowserHistory />

export default App
